import { usePageDataStore } from '@mc/globalStore';
import type { GetPageDataResponse } from './autolyse/mailchimp.appshell.v1/PageDataService';

const getConfigFromPageDataStore = () => {
  if (usePageDataStore) {
    return usePageDataStore.getState().appConfig;
  }
};

// eslint-disable-next-line import/no-mutable-exports
let config = window.reactify_gpd ? null : getConfigFromPageDataStore();

export const setConfig = (data: GetPageDataResponse['appConfig']) => {
  if (!config) {
    config = data;
  }
};

export const kbLocales = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  'pt-br': 'Português',
  de: 'Deutsch',
  it: 'Italiano',
};

export { config as default };
